import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function SolidSquareShapeIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M17 2H7C4.2 2 2 4.2 2 7v10c0 2.8 2.2 5 5 5h10c2.8 0 5-2.2 5-5V7c0-2.8-2.2-5-5-5Z"/>
  </SvgIcon>
}

export default SolidSquareShapeIcon
